import initAboutSlider from "./init-about-slider";
import initBarriersSlider from "./init-barriers-slider";
import initCasesSlider from "./init-cases-slider";
import initLicenseSlider from "./init-license-slider";
import initPlatformSlider from "./init-platform-slider";
import initReviewsSlider from "./init-reviews-slider";
import initTeachersSlider from "./init-teachers-slider";
import initTeamSlider from "./init-team-slider";
import initVideosSlider from "./init-videos-slider";
import initWorthSlider from "./init-worth-slider";
import initProjectSlider from "./init-projectportfolio-slider";
import initOfficeSlider from "./init-office-slider";
import initRequirementSlider from "./init-requirement-slider";
import initWhoWillSlider from "./init-whowill-slider";
import initAfterSlider from "./init-after-slider";
import initProgrammSlider from "./init-programm-slider";
import initPaySlider from "./init-pay-slider";
import initTrainingSlider from "./init-training-slider";
import initTeamSliderNew from "./init-team-slider-new";
import initFeedbackSlider from "./init-feedback-slider";
import initHrFeedbackSlider from "./init-hr-feedback";
import initCoachesSlider from "./init-coaches-slider";




const sliders = () => {
  initTeachersSlider();
  initReviewsSlider();
  initCasesSlider();
  initWorthSlider();
  initTeamSlider();
  initBarriersSlider();
  initAboutSlider();
  initPlatformSlider();
  initVideosSlider();
  initLicenseSlider();
  initProjectSlider();
  initOfficeSlider();
  initRequirementSlider();
  initWhoWillSlider();
  initAfterSlider();
  initProgrammSlider();
  initTrainingSlider();
  initTeamSliderNew();
  initHrFeedbackSlider();
  //initPaySlider();
  initFeedbackSlider();
  initCoachesSlider();
};

export default sliders;
